import * as React from 'react';

import {Button} from 'shells/button/button';
import {LoadingPage} from 'shells/loading-page/loading-page';

import {CalendarOptionsRadioGroups} from '../calendar-options-radio-groups';
import {useGetCalendarSync} from '../graphql/hooks';

import {CalendarModalPage} from './calendar-modal-page';

type Props = {
    goBack: () => void;
    nextPage: () => void;
};

export function CalendarSettings(props: Props) {
    const {calendarSync} = useGetCalendarSync();

    if (!calendarSync) {
        return <LoadingPage />;
    }

    const selectedCalendar = calendarSync.calendars.find(
        (calendar) => calendar.syncType === 'PRIMARY'
    );

    const isDisabled = !calendarSync.isEnabled || !selectedCalendar;

    return (
        <CalendarModalPage
            header='Configure your settings'
            navButtons={
                <>
                    <Button variant='text' size='big' onClick={props.goBack}>
                        Back
                    </Button>
                    <Button variant='save' size='big' onClick={props.nextPage}>
                        Continue
                    </Button>
                </>
            }
        >
            <CalendarOptionsRadioGroups
                calendarSync={calendarSync}
                isDisabled={isDisabled}
                hideIllustrations={true}
                hideSelectCalendar={true}
            />
        </CalendarModalPage>
    );
}
